import { useDispatch } from 'react-redux';
import { useSignConsentMutation } from './service';
import { updatePrivacyConsent } from '../../../redux/config/actions';

const usePrivacyConsent = () => {
  const dispatch = useDispatch();
  const [signConsent, { isLoading: isLoadingSignConsent }] =
    useSignConsentMutation();

  const handleSubmitPrivacyConsent = async (e) => {
    e.preventDefault();

    if (isLoadingSignConsent) return;

    const response = await signConsent();

    if (response?.data?.success) {
      dispatch(
        updatePrivacyConsent({
          consent_signed: true,
          outdated: false,
        })
      );
    }
  };

  return {
    handleSubmitPrivacyConsent,
    isLoadingSignConsent,
  };
};

export default usePrivacyConsent;
